import React from 'react';
import PropTypes from 'prop-types';

const ClickableWrap = (props) => {
    return props.url || props.onClick ? (
        <a
            href={props.url}
            target={props.openInNewTab ? '_blank' : undefined}
            onClick={props.onClick}
            className={props.className}
        >
            {props.children}
        </a>
    ) : (
        props.children
    );
};

ClickableWrap.propTypes = {
    url: PropTypes.string,
    openInNewTab: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string
};

ClickableWrap.defaultProps = {
    url: undefined,
    openInNewTab: false,
    onClick: undefined,
    children: null,
    className: undefined
};

export default ClickableWrap;
